module.exports = __webpack_public_path__ + "fd5a608a/img/24000000-4.74be22f6.png";